import { useLingui } from '@lingui/react/macro';
import { Upload } from 'lucide-react';
import type { DropzoneState } from 'react-dropzone';

export interface DropZoneContentProps {
  dropzone: DropzoneState;
  maxSize?: number;
}

export function DropZoneContent({ dropzone, maxSize }: DropZoneContentProps) {
  const { t } = useLingui();

  if (dropzone.isDragAccept) {
    return <div className='text-sm font-medium'>{t`Drop your files here`}</div>;
  }

  return (
    <div className='flex flex-col items-center gap-1.5'>
      <div className='flex flex-row items-center gap-0.5 text-sm font-medium'>
        <Upload className='mr-2 size-4' />
        {t`Upload files`}
      </div>
      {maxSize && (
        <div className='text-xs font-medium text-gray-400'>
          {t`Max. file size: ${maxSize / 1024 / 1024} MB`}
        </div>
      )}
    </div>
  );
}
